import { parseExchangeField } from '@/lib/proto/util'
import { Exchange } from '@/types/generated/common/types'

/**
 * Identity for "same visual row". Account is part of the key so positions on
 * two accounts at the same venue render as separate OrderRow cards instead of
 * one account silently replacing the other. Always normalizes `exchange` via parseExchangeField (raw
 * `exchange` can arrive as undefined, a string enum name, or a numeric enum —
 * two representations of the same exchange must not produce different keys)
 * and normalizes `symbol` casing/whitespace, so callers never need to
 * pre-normalize either field themselves.
 */
export function getRowGroupKey(
  item: { accountId?: string; exchange?: string; itemType: string; symbol: string },
  primaryExchange: Exchange
): string {
  const exchange = parseExchangeField(item.exchange, primaryExchange)
  return `${exchange}:${item.accountId ?? ''}:${item.itemType}:${item.symbol.trim().toUpperCase()}`
}
